import { type ComponentProps, forwardRef } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

const buttonGroup = tailwindVariants({
  base: 'flex shrink-0 [&>*]:rounded-none [&>*:not(:first-child)]:border-l-0',
  defaultVariants: {
    size: 'medium',
  },
  variants: {
    size: {
      medium: [
        '[&>*:first-child]:rounded-tl-8 [&>*:first-child]:rounded-bl-8',
        '[&>*:last-child]:rounded-tr-8 [&>*:last-child]:rounded-br-8',
      ],
      small: [
        '[&>*:first-child]:rounded-tl-4 [&>*:first-child]:rounded-bl-4',
        '[&>*:last-child]:rounded-tr-4 [&>*:last-child]:rounded-br-4',
      ],
    },
  },
});

type ButtonGroupVariants = VariantProps<typeof buttonGroup>;

export type ButtonGroupProps = Omit<ComponentProps<'div'>, keyof ButtonGroupVariants> & ButtonGroupVariants;

export const ButtonGroup = forwardRef<HTMLDivElement, ButtonGroupProps>(
  ({ className, size, ...restOfProps }, forwardedRef) => {
    return <div className={buttonGroup({ className, size })} {...restOfProps} ref={forwardedRef} />;
  },
);

ButtonGroup.displayName = 'ButtonGroup';
